module.exports = __webpack_public_path__ + "logo.png?fdd7c1bd83838254b5094c64387d4c57";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.png
// module id = 46
// module chunks = 0